import React from "react";

export const PageComponent = ({
  children,
  content,
  btnFunctions,
  disabled,
  disabledArray = [],
  snippets = {},
  noHeader = false,
  styles = {},
  innerStyles = {},
  children2,
}) => {
  const stripHtml = (input) => input.replace(/<\/?[^>]+(>|$)/g, "");

  const replaceSnippets = (snippets, input) => {
    let a = input;
    Object.keys(snippets).forEach((key) => {
      const regex = new RegExp(`\\[${key}\\]`, "g");
      a = a.replace(regex, snippets[key]);
    });
    return a;
  };

  return (
    <>
      {content && (
        <div>
          <div
            className="header_fontFamily panelHeader"
            style={{ display: noHeader ? "none" : "block" }}
          >
            <h1>
              {stripHtml(replaceSnippets(snippets, content?.header) || "")}
            </h1>
          </div>
          <div className="panelContent body_fontFamily" style={styles}>
            {content.title && (
              <h2
                className="body_fontFamily"
                dangerouslySetInnerHTML={{
                  __html: replaceSnippets(snippets, content.title),
                }}
              />
            )}
            <p
              className="body_fontFamily"
              dangerouslySetInnerHTML={{
                __html: replaceSnippets(snippets, content?.body || ""),
              }}
            />
            <div style={innerStyles} className="pb-3">
              {children}

              {content?.body2 && (
                <>
                  <p
                    className="body_fontFamily"
                    dangerouslySetInnerHTML={{
                      __html: replaceSnippets(snippets, content?.body2 || ""),
                    }}
                  />
                  {children2}
                </>
              )}

              {content.buttons && content.buttons.length > 0 && (
                <div className="d-flex buttons_fontFamily">
                  {content.buttons.map((button, i) => {
                    return (
                      <div
                        className={(i !== 0 ? "pl-2 " : "") + "buttonBar"}
                        key={i}
                      >
                        <button
                          title={stripHtml(button)}
                          className="button primary buttons_fontFamily"
                          style={{ padding: "6px 12px" }}
                          onClick={btnFunctions?.[i] || (() => {})}
                          disabled={disabled || disabledArray[i]}
                        >
                          <div>
                            {stripHtml(replaceSnippets(snippets, button))}
                          </div>
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
